module.exports = __webpack_public_path__ + "static/media/spot-gray.5600079d.svg";